import initialState from './initialState';

export function promotionListHasErrored(
  state = initialState.promotionListHasErrored,
  action,
) {
  switch (action.type) {
    case 'PROMOTION_LIST_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function promotionListIsLoading(
  state = initialState.promotionListIsLoading,
  action,
) {
  switch (action.type) {
    case 'PROMOTION_LIST_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function promotionList(state = initialState.promotionList, action) {
  switch (action.type) {
    case 'PROMOTION_LIST_FETCH_DATA_SUCCESS':
      return action.promotionList;
    default:
      return state;
  }
}

export function promotionDetailsHasErrored(
  state = initialState.promotionDetailsHasErrored,
  action,
) {
  switch (action.type) {
    case 'PROMOTION_DETAILS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function promotionDetailsIsLoading(
  state = initialState.promotionDetailsIsLoading,
  action,
) {
  switch (action.type) {
    case 'PROMOTION_DETAILS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function promotionDetails(
  state = initialState.promotionDetails,
  action,
) {
  switch (action.type) {
    case 'PROMOTION_DETAILS_FETCH_DATA_SUCCESS':
      return action.promotion;
    default:
      return state;
  }
}

export function isNewPromotionSaveSuccess(
  state = initialState.isNewPromotionSaveSuccess,
  action,
) {
  switch (action.type) {
    case 'NEW_PROMOTION_SAVE_SUCCESS':
      return {
        isSavedSuccess: action.isSavedSuccess,
        promotion: action.promotion,
      };
    default:
      return state;
  }
}

export function isNewPromotionSaveErrored(
  state = initialState.isNewPromotionSaveErrored,
  action,
) {
  switch (action.type) {
    case 'NEW_PROMOTION_SAVE_ERRORED':
      return {
        isSaveErrored: action.isSaveErrored,
        message: action.message,
      };
    default:
      return state;
  }
}

export function isNewPromotionIsSaving(
  state = initialState.isNewPromotionIsSaving,
  action,
) {
  switch (action.type) {
    case 'NEW_PROMOTION_IS_SAVING':
      return action.isSaving;
    default:
      return state;
  }
}

export function redirectToPromotionListPage(
  state = initialState.redirectToPromotionListPage,
  action,
) {
  switch (action.type) {
    case 'REDIRECT_TO_PROMOTION_LIST':
      return action.doRedirectToPromotionListPage;
    default:
      return state;
  }
}
